import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Control } from 'react-redux-form';
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import {
    ORFButton as Button
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_TextArea as TextArea
} from '../../../../common/forms/order-request-form.component';
import { ControlCheckBox } from '../../../../common/custom-form/checkbox.component';
import { wirelessReplaceDeviceActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-replace-device.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import Translation from "../../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation, CIRCUIT_TYPES as CircuitTypes } from '../../../../../utils/constant.utils';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../common/modal/confirmation-modal.component';
import { withRouter } from 'react-router-dom';
import { CIRCUIT_STATUS } from '../../../../../constants/external-constants';
import { MAX_LENGTH } from './../../../../../constants/external-constants';
import CustomSearchableSelectWrapper from '../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { SUBMIT_REQUEST_TITLE } from '../../../../../constants/external-constants';
import { convertToDecimal } from '../../../../../utils/helpers.utils';
import CustomSearchableDropdownWrapper from '../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';
import { ChatbotActions } from "./../../../../../store/common/chatbot/chatbot.reducer";
import { validateApproverBeforeSubmit } from '../../../../../utils/request-approver-validation.utils';
import { httpGet} from '../../../../../utils/api.utils';


class ReplaceDeviceForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            message: "",
            showConModal: false,
            title: "",
            error: false,
            isSaving: false,
            isValidation: false,
            isReplaceUpgradeEligible: false,
            isEquipmentSelected: false,
            cachedEquipmentOptions: [],
            isKyberProcAuthorized: false,
            isKyberProcAuthorizationLoaded: false
        }
        this.SearchSuggestions = React.createRef();
    }

    async componentDidMount() {
        this.loadKyberProcAuthorization();
        const { isUpdateRequest, takeActionCircuitCode, takeActionCircuitId } = this.props.createRequest;
        const { requestDetail, fetchSubscriptionByRequestDetail, updateSubscriptionDetails, setLoadForm, onCircuitSelect, fetchSubscriptionByValue } = this.props;
        this.props.resetWirelessReplaceDeviceForm();
        this.props.getReplaceDeviceFormData();
        this.props.onCountrySelect("wirelessLocationFormA.countryCode", this.props.wirelessReplaceDeviceFormA?.countryCode);

        if (takeActionCircuitId != null || takeActionCircuitId !== undefined || takeActionCircuitCode) {
            var circuitCodePropName = 'CircuitCode';
            var subscriptionList = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

            onCircuitSelect(takeActionCircuitCode, circuitCodePropName, subscriptionList, null, takeActionCircuitId);
        }
        else {
            onCircuitSelect('');
        }

        if (isUpdateRequest) {
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;
            var circuitCodePropName = 'CircuitCode';

            setLoadForm(true);
            var subscriptionList = await fetchSubscriptionByRequestDetail(currentCircuitCode, circuitCodePropName);
            await updateSubscriptionDetails(subscriptionList, circuitCodePropName);
            this.SearchSuggestions.current.onChange(null, { newValue: requestDetail.requestData.Circuit.CircuitCode })
            setLoadForm(false);
        }
    }

    handleWindowFocus = () => {
        this.loadKyberProcAuthorization();
    };
    componentWillUnmount() {
        this.props.resetWirelessReplaceDeviceForm();
        this.props.resetRequestData();
    }
    componentDidUpdate(prevProps) {
        const previousEquipmentOptions =
            prevProps
                ?.wirelessReplaceDeviceRequest
                ?.equipmentOptions || [];

        const currentEquipmentOptions =
            this.props
                ?.wirelessReplaceDeviceRequest
                ?.equipmentOptions || [];

        if (
            currentEquipmentOptions !==
            previousEquipmentOptions &&
            Array.isArray(
                currentEquipmentOptions
            ) &&
            currentEquipmentOptions.length >= 2
        ) {
            this.setState({
                cachedEquipmentOptions:
                    currentEquipmentOptions
            });
        }

        const {
            wirelessReplaceDeviceFormA,
            checkReplaceUpgradeEligibility
        } = this.props;

        if (
            prevProps
                .wirelessReplaceDeviceFormA
                .circuitId !==
            wirelessReplaceDeviceFormA
                .circuitId
        ) {
            checkReplaceUpgradeEligibility(
                wirelessReplaceDeviceFormA
                    .circuitId
            ).then(isEligible => {
                this.setState({
                    title:
                        this.toLocaleLanguage(
                            "upgrade_eligibility"
                        ),

                    show:
                        isEligible,

                    message:
                        this.toLocaleLanguage(
                            "upgrade_eligible"
                        ),

                    isValidation:
                        isEligible,

                    isReplaceUpgradeEligible:
                        isEligible,

                    isEquipmentSelected:
                        false
                });
            });
        }
    }
    
    submitRequest = () => {
        this.setState({ showConModal: true })
    }

    handleConfirmationModal = async (buttonType) => {

        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { submitRequest, fetchRequestLogItems, createRequest } = this.props;
            const isUpdateRequest = createRequest ? createRequest.isUpdateRequest : false;
            this.setState({
                isSaving: true,
            });
            var success = await submitRequest(this.state.isReplaceUpgradeEligible);
            if (success.Success) {
                fetchRequestLogItems(0);
                this.setState({
                    title: "Success",
                    isSaving: false
                })
                this.props.hideRequestModal();
            } else {
                this.setState({
                    title: "Error",
                    isSaving: false
                })
            }
            this.setState(prev => ({
                showConModal: !prev.showConModal,
                show: true,
                message: success.ok != false ? (isUpdateRequest && success.Success) ? this.toLocaleLanguage("order_has_been_updated") : success.Message : 'Incorrect Data'
            }))
        } else {
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false });
        if (this.state.title !== "Error") {
            if (!this.state.isValidation) {
                this.props.history.goBack();
            }
        }
        this.setState({
            isValidation: false
        });
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    renderPopover = (title, body) => {
        return (
            <Popover id="comp-popover" title={title} className="plan-comp-popover">
                {body}
            </Popover>
        );
    };

    onServiceTypeSelect(val, e) {
        const { onServiceTypeSelect } = this.props;

        this.setState({ isEquipmentSelected: true });
        onServiceTypeSelect(val, e);
    }

    findOptionValue = (options, key) => {
        if (!options || !Array.isArray(options)) return "";
        const k = key?.toString?.() ?? `${key}`;
        const match = options.find(o => (o?.Key?.toString?.() ?? `${o?.Key}`) === k);
        return match?.Value ?? "";
    };

    openAskAi = async (payload) => {
        if (!this.canUseKyberProcAskAi()) {
            return;
        }
        const entrySource = payload?.entrySource || "plan_link";
        const isDevice = entrySource === "service_type_link";
        const contextType = isDevice ? "device_advisor" : "plan_advisor";
        const startMsg = isDevice ? "DEVICE_ADVISOR_START" : "PLAN_ADVISOR_START";

        await this.props.setContext(contextType, payload, entrySource);
        this.props.toggleChat(true);
        await this.props.sendMessage(startMsg, 0, 0, false, 0, false);
    };

    loadKyberProcAuthorization = async () => {
        try {
            const result =
                await httpGet(
                    'external/kyberconfig/kyber-proc-agent/enabled'
                );

            if (
                result == null ||
                result?.ok === false
            ) {
                throw new Error(
                    'Unable to retrieve KyberProc authorization.'
                );
            }

            const isAuthorized =
                result?.isEnabled === true ||
                result?.IsEnabled === true;

            this.setState({
                isKyberProcAuthorized: isAuthorized,
                isKyberProcAuthorizationLoaded: true,
            });

            return isAuthorized;
        } catch (error) {
            console.error(
                'KyberProc authorization check failed:',
                error
            );

            this.setState({
                isKyberProcAuthorized: false,
                isKyberProcAuthorizationLoaded: true,
            });

            return false;
        }
    };

    canUseKyberProcAskAi = () =>
        this.state.isKyberProcAuthorizationLoaded === true &&
        this.state.isKyberProcAuthorized === true;

    render() {
        const { subscriptionList, takeActionCircuitCode, isUpdateRequest, isRequestOnBehalf, requestOnBehalfData } = this.props.createRequest;
        const { wirelessReplaceDeviceFormA
            , onCircuitSelect
            , setRequestorAddress
            , fetchSubscriptionByValue
            , onCountrySelect
            , onAddressSelect

            , handleMobServiceTypeSearch
            , loadMoreMobServiceType

            , handleAddressSearch
            , loadMoreAddress
        } = this.props;

        const { requestData } = this.props.requestDetail;
        const { equipmentOptions
            , countryOptions
            , addressOptions
            , serviceTypeDetail
            , formSubmitted
            , subscription
            , isResetLoading

            , isMobServiceTypeLoading
            , hasMoreMobServiceType

            , isAddressLoading
            , hasMoreAddress

            , isCountryLoading
            , hasMoreCountry
        } = this.props.wirelessReplaceDeviceRequest;
        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";

        let isROB = isRequestOnBehalf && (requestOnBehalfData.EmployeeId === '' || requestOnBehalfData.EmployeeId === 0)
        var showPreferredAddress = wirelessReplaceDeviceFormA.billingLocationAddressId.toString() === "-1";

        let disable = wirelessReplaceDeviceFormA.countryCode == ''
            || wirelessReplaceDeviceFormA.billingLocationAddressId === '' || isROB;

        if (showPreferredAddress) {
            disable = disable || wirelessReplaceDeviceFormA.otherLocationAddress === '';
        }

        var isNotValidLocationAddress = wirelessReplaceDeviceFormA.billingLocationAddressId === ""
            || showPreferredAddress && wirelessReplaceDeviceFormA.otherLocationAddress.trim() === "";

        var discountedOrderCost = "";
        var orderCost = "";
        var isDiscountedOrderCostChanged = false;
        var isOrderCostChanged = false;

        if (isUpdateRequest && this.state.isEquipmentSelected) {

            if (this.state.isReplaceUpgradeEligible) {
                discountedOrderCost = wirelessReplaceDeviceFormA.mobileServiceModel.length > 0 ? wirelessReplaceDeviceFormA.mobileServiceModel[0]?.DiscountedOrderCost : requestData.Subscription.DiscountedOrderCost;
                isDiscountedOrderCostChanged = requestData.Subscription.DiscountedOrderCost !== serviceTypeDetail.DiscountedOrderCost;
            }
            else {
                isOrderCostChanged = requestData.Subscription.OrderCost !== serviceTypeDetail.OrderCost;
                orderCost = serviceTypeDetail.OrderCost;
            }
        }
        else if (isUpdateRequest && !this.state.isEquipmentSelected) {
            discountedOrderCost = requestData.Subscription.DiscountedOrderCost;
            orderCost = requestData.Subscription.OrderCost;
        }
        else if (!isUpdateRequest) {
            discountedOrderCost = serviceTypeDetail.DiscountedOrderCost != null || serviceTypeDetail.DiscountedOrderCost != undefined
                ? serviceTypeDetail.DiscountedOrderCost : "0.00";

            orderCost = serviceTypeDetail.OrderCost != null || serviceTypeDetail.OrderCost != undefined
                ? serviceTypeDetail.OrderCost : "0.00";
        }


        const initialRequired = wirelessReplaceDeviceFormA.circuitId == 0
            || wirelessReplaceDeviceFormA.countryCode === ''
            || isNotValidLocationAddress
            || wirelessReplaceDeviceFormA.equipmentInventoryId == 0
            || isROB
            || formSubmitted;
        const updateRequired = !((requestData.OtherLocationName != '' ? requestData.OtherLocationName != wirelessReplaceDeviceFormA.otherLocationAddress : wirelessReplaceDeviceFormA.otherLocationAddress != '')
            || requestData.BillingAddress.LocationId != wirelessReplaceDeviceFormA.billingLocationAddressId
            || requestData.BillingAddress.CountryCode != wirelessReplaceDeviceFormA.countryCode
            || requestData.Subscription.EquipmentInventoryId != wirelessReplaceDeviceFormA.equipmentInventoryId
            || requestData.Subscription.PhoneCaseAccessory != wirelessReplaceDeviceFormA.phoneCaseAccessory
            || (requestData.BusinessJustification.AdditionalInformation != null ? (requestData.BusinessJustification.AdditionalInformation != wirelessReplaceDeviceFormA.additionalInformation) : (wirelessReplaceDeviceFormA.additionalInformation != null ? wirelessReplaceDeviceFormA.additionalInformation != '' : false))
            || (isUpdateRequest && this.state.isReplaceUpgradeEligible ? isDiscountedOrderCostChanged : isOrderCostChanged)
        );

        const accessoryCost = wirelessReplaceDeviceFormA.accessoryDetailsModel.length > 0 ?
            wirelessReplaceDeviceFormA.accessoryDetailsModel.reduce((accum, item) => accum + item.OrderCost, 0) : 0;

        return (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
                <ConfirmationNotificationModal
                    show={this.state.showConModal}
                    message={isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")}
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest : this.toLocaleLanguage("submit_form_request_title")}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                    disabled={this.state.isSaving}
                />
                <Form method="post" role="form"
                    model="wirelessReplaceDeviceFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row className='search-suggestion'>
                        <Col className='service-type-container required' xs={12} md={12} lg={12}>
                            {!isResetLoading &&
                                <SearchSuggestions
                                    ref={this.SearchSuggestions}
                                    value={wirelessReplaceDeviceFormA.circuitCode}
                                    label={`${this.toLocaleLanguage('mobile_phone_number')}`}
                                    propDisplay={'CircuitCode'}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    options={subscriptionList.length > 0 ? subscriptionList : ''}
                                    onChangeAction={onCircuitSelect}
                                    searchAction={fetchSubscriptionByValue}
                                    defaultValue={takeActionCircuitCode}
                                    maxLength={MAX_LENGTH.limit_100}
                                    errorMessage={this.toLocaleLanguage('error_mobile_number_not_exist')}
                                    haveError={this.haveError}
                                />
                            }
                        </Col>
                        {wirelessReplaceDeviceFormA.circuitCode != '' &&
                            <div className="pb-15-pl-30">
                                <span className={circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{circuitStatusName} </span> <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? subscriptionList[0].VendorName : subscription.VendorName != null && subscription.VendorName != "" ? subscription.VendorName : ""} <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? subscriptionList[0].PlanName : subscription.PlanName != null && subscription.PlanName != "" ? subscription.PlanName : <Translation translationKey="no_plan_available" />} <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? subscriptionList[0].DeviceName : subscription.DeviceName != null && subscription.DeviceName != '' ? subscription.DeviceName
                                    : <Translation translationKey="no_device_available" />}
                            </div>
                        }
                    </Row>
                    <div>
                        <span className='text-field-title'><Translation translationKey="replace_upgrade" /></span>
                        <Row>
                            <Col className="requesto-info-container required mb-3" xs={12} md={12} lg={12}>
                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage("mobile_service_type")}`}
                                    labelRight={
                                        this.canUseKyberProcAskAi() &&
                                            Number(
                                                wirelessReplaceDeviceFormA
                                                    .equipmentInventoryId || 0
                                            ) > 0 ? (
                                            <span
                                                className="ask-ai-inline"
                                                onClick={() => {
                                                    const equipmentId = Number(wirelessReplaceDeviceFormA.equipmentInventoryId || 0);
                                                    const equipmentModel = this.findOptionValue(equipmentOptions, equipmentId);

                                                    const currentEquipmentOptions = Array.isArray(equipmentOptions) ? equipmentOptions : [];
                                                    const cachedEquipmentOptions = Array.isArray(this.state.cachedEquipmentOptions)
                                                        ? this.state.cachedEquipmentOptions
                                                        : [];

                                                    const sourceOptions = currentEquipmentOptions.length >= 2 ? currentEquipmentOptions : cachedEquipmentOptions;

                                                    const allowedEquipmentIds = sourceOptions
                                                        .map(o => Number(o?.Key ?? 0))
                                                        .filter(n => Number.isFinite(n) && n > 0);

                                                    const payload = {
                                                        entrySource: "service_type_link",
                                                        selectedEquipmentInventoryId: equipmentId,
                                                        selectedEquipmentModel: equipmentModel,
                                                        circuitId: Number(wirelessReplaceDeviceFormA.circuitId ?? 0),
                                                        circuitTypeId: Number(serviceTypeDetail?.CircuitTypeId ?? subscription?.CircuitTypeId ?? 0),
                                                        allowedEquipmentIds,
                                                    };

                                                    if (!allowedEquipmentIds || allowedEquipmentIds.length < 2) {
                                                        console.warn("Ask AI: allowedEquipmentIds has < 2 items. Cannot compare within selection reliably.");
                                                    }
                                                    this.openAskAi(payload);
                                                }}
                                            >
                                                Ask AI ✨
                                            </span>
                                        ) : null
                                    }
                                    options={equipmentOptions}
                                    selected={wirelessReplaceDeviceFormA.equipmentInventoryId}
                                    onChange={(e) =>
                                        this.onServiceTypeSelect("wirelessReplaceDeviceFormA.equipmentInventoryId", e)
                                    }
                                    placeholder={this.toLocaleLanguage("select_placeholder")}
                                    fieldProp=".equipmentInventoryId"
                                    maxLength={MAX_LENGTH.limit_100}
                                    optionLabelKey={{ Key: "Key", Value: "Value" }}
                                    onSearchChange={handleMobServiceTypeSearch}
                                    onLoadMore={loadMoreMobServiceType}
                                    isLoading={isMobServiceTypeLoading}
                                    hasMore={hasMoreMobServiceType}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="checkbox-container">
                        {serviceTypeDetail.CircuitTypeId == CircuitTypes.mobile_or_cellphone &&
                            <ControlCheckBox
                                classWrapper="custom-checkbox-wrapper mb-3"
                                label={`${this.toLocaleLanguage('include_phone_accessory')}`}
                                model="wirelessReplaceDeviceFormA.phoneCaseAccessory"
                                checked={wirelessReplaceDeviceFormA.phoneCaseAccessory}
                            />
                        }
                    </div>
                    <div className="price-plan-total-cost-container">
                        <div className="price-plan-header">
                            <span><Translation translationKey="total_order_cost" /></span>
                        </div>
                        <div className="price-plan-total">
                            <span>{subscription.CurrencyName}</span>

                            <span>{wirelessReplaceDeviceFormA.equipmentInventoryId != 0 ? this.state.isReplaceUpgradeEligible ? convertToDecimal(discountedOrderCost) : convertToDecimal(orderCost) : "0.00"}</span>
                        </div>
                    </div>
                    <Row>
                        <div className='use-request-container'>
                            <span onClick={setRequestorAddress} className="requestor-address-link"><Translation translationKey="use_requestor_address" /></span>
                        </div>
                        <Col className='requesto-info-container required mb-3' xs={12} md={12} lg={12}>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('country')}`}
                                options={countryOptions}
                                selected={wirelessReplaceDeviceFormA.countryCode}
                                onChange={(e) => onCountrySelect('wirelessReplaceDeviceFormA.countryCode', e)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.countryCode'
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                isNullable={true}
                                onSearchChange={this.props.handleCountrySearch}
                                onLoadMore={(e) => this.props.loadMoreCountry(e)}
                                isLoading={isCountryLoading}
                                hasMore={hasMoreCountry}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='requesto-info-container required mb-3' xs={12} md={12} lg={12}>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('delivery_address')}`}
                                options={addressOptions}
                                selected={wirelessReplaceDeviceFormA.billingLocationAddressId}
                                onChange={(e) => onAddressSelect('wirelessReplaceDeviceFormA.billingLocationAddressId', e)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.billingLocationAddressId'
                                maxLength={MAX_LENGTH.limit_500}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}

                                onSearchChange={handleAddressSearch}
                                onLoadMore={loadMoreAddress}
                                isLoading={isAddressLoading}
                                hasMore={hasMoreAddress}
                            />
                            {
                                (wirelessReplaceDeviceFormA.deliveryAddress !== '' && !disable) &&
                                <div className={`delivery-address-label ${showPreferredAddress ? "mb-3" : ""}`}>
                                    {wirelessReplaceDeviceFormA.deliveryAddress}
                                </div>
                            }
                        </Col>
                    </Row>
                    {showPreferredAddress &&
                        <Row>
                            <Col className='required' xs={12} md={12} lg={12}>
                                <TextArea label={`${this.toLocaleLanguage('preferred_delivery_address')}`}
                                    fieldProp='.otherLocationAddress'
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    value={wirelessReplaceDeviceFormA.otherLocationAddress}
                                    maxLength={MAX_LENGTH.limit_255}
                                />
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                value={wirelessReplaceDeviceFormA.additionalInformation}
                                maxLength={MAX_LENGTH.limit_1000}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={isUpdateRequest ? (initialRequired || updateRequired) : initialRequired}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter(connect(
    state => {
        const { createRequest, wirelessReplaceDeviceRequest, requestDetail, setLoadForm, translation } = state;
        const { wirelessReplaceDeviceFormA } = state.form;
        return {
            wirelessReplaceDeviceFormA
            , createRequest
            , wirelessReplaceDeviceRequest
            , requestDetail
            , setLoadForm
            , ...translation,
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessReplaceDeviceActions
                , createRequestActions
                , requestLogActions
                , ChatbotActions),
            dispatch
        )
)(ReplaceDeviceForm));